import styled from "styled-components";

export const MainDiv = styled.div`
  padding: 16px;
  width: 100%;
  max-width: 600px;
  display: flex;
  flex-direction: column;
  background-color: #f3f3f3;
  border-radius: 5px;
`;
export const SectionTitle = styled.p`
  color: #808080;
  font-size: 14px;
  font-weight: 600;
`;
export const FormSection = styled.div`
  margin: ${({ margin }) => margin && margin};
  padding: 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-radius: 5px;
  background-color: #fff;
`;
export const FormTitle = styled.p`
  margin-bottom: 16px;
  color: #000;
  font-size: 14px;
  font-weight: 600;
`;
export const ColumnsDiv = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-around;
`;
export const ColumnDiv = styled.div`
  width: 42%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 8px;
`;
export const InputDiv = styled.div`
  width: 100%;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
`;
export const Label = styled.label`
  color: #000;
  font-size: 14px;
  font-weight: 500;
  text-align: right;
`;
export const Input = styled.input`
  padding: 4px 8px;
  width: 80px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  border: 1px solid #e2e2e2;
  outline: none;
  text-align: center;
`;
export const ActionsDiv = styled.div`
  width: 100%;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
export const CancelButton = styled.button`
  padding: 8px 20px;
  width: 190px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  border: 1.5px solid #26a9b6;
  color: #26a9b6;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
`;
export const SaveButton = styled.button`
  padding: 8px 20px;
  width: 190px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  border: none;
  background: #26a9b6;
  box-shadow: 0px 1px 0px 0px #1c7983;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  pointer-events: ${({ disabled }) => (disabled ? "none" : "auto")};
`;
